<template>
<div>
  <div class="radio__label">   
	<div class="radio-group" v-if="!onlyMonthly">
		<div class="radio__part">
			<input id="oneTime" type="radio" class="frequency" :checked="type == 'single'" @click="setSingle"/>
			<FormLabel for="oneTime">{{ isEs ? 'Una vez' : 'One time' }}</FormLabel>
		</div>
		<div class="radio__part" v-if="addMonthly">
			<input id="monthly" type="radio" class="frequency" :checked="type == 'monthly'" @click="setMonthly"/>
			<FormLabel for="monthly">{{ isEs ? 'Mensual' : 'Monthly' }}</FormLabel>		
		</div>
		<div class="radio__part" v-if="addSplit">
			<input id="split" type="radio" class="frequency" :checked="type == 'split'" @click="setSplit"/>
			<FormLabel for="split">Split Payment</FormLabel>		
		</div>
	</div>
  <div class="monthly-note" v-if="type === 'split'">
    <select :value="duration" @change="e => setValue('periodMonths', e.target.value)">
      <template v-for="i in splitMonths" :key="i">
        <option v-if="i >= 2" :value="i">{{i}} Months</option>
      </template>
    </select>
    <div v-if="splitAmount">
      {{splitAmount}}
    </div>
    <div v-else>
      Please select amount to split, and number of months
    </div>
  </div>
   </div>
	<div class="monthly-note"  v-if="type === 'monthly'">    
    <div v-if="isEs">
      Tu donación se realizará hoy y el día <strong>{{ form.dayOfMonth }}</strong> de cada mes siguiente mediante el método de pago seleccionado. Puede cambiar o cancelar esta cantidad en cualquier momento.
    </div>
    <div v-else>
      Your donation will be made today and on the <strong>{{monthDay}}</strong> of each following month using the payment method selected. You may change or cancel this amount at any time.
    </div>
  </div>
    <div class="months-selector monthly-note" v-if="monthesSelector && type === 'monthly'">
      {{ isEs ? 'Repetir por' : 'Repeat for' }}
      <select :value="duration" @change="(e) => setValue('periodMonths', e.target.value || null)">
        <option value="">{{ isEs ? 'Indefinido' : 'Indefinite' }}</option>
        <template v-for="i in 12" :key="i">
          <option v-if="i >= 2" :value="i">
            {{ i }} {{ isEs ? 'Meses' : (i == 1 ? "Month" : "Months") }}
          </option>
        </template>
      </select>
      {{ isEs ? 'meses' : 'months' }}
    </div>  
  <div class="selectdoantion__label"  v-if="type !== 'monthly'">{{ isEs ? 'Monto de donación' : 'Donation Amount' }}</div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
  onMounted
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

function round (number: number) {
  return Math.floor(number * 100) / 100
}
export default defineComponent({  props: {
    addSplit: {
      type: Boolean,
      default: false,
    },
    splitMonths: {
      type: Number,
      default: 12
    },
    monthesSelector: {
      type: Boolean,
      default: false,
    },    
    addMonthly: {
      type: Boolean,
      default: false
    },
    onlyMonthly: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: 'en'
    },
  },
  setup(props) {
    const { form, setValue } = usePaymentForm()
    const isEs = computed(() => props.lang === 'es')

    const type = ref<'single' | 'monthly' | 'split'>('single')

    const splitAmount = computed(() => {
      if (!form.value.amount) return

      const recurringAmount = Math.round(Number(form.value.amount) / Number(form.value.periodMonths))
    
      const totalAmount = recurringAmount * +form.value.periodMonths!;

      var difference = Number(form.value.amount) - totalAmount;

      var initialAmount = recurringAmount + difference;

      if (initialAmount != recurringAmount) {
        return `One payment of ${form.value.currency == 'ILS'? '₪' : '$'}${initialAmount} and ${+form.value.periodMonths! - 1} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
      else {
        return `${form.value.periodMonths} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
    })

    onMounted(() => {
      if(props.onlyMonthly) {
        type.value = 'monthly'
        // keep the chosen "Repeat for" when the step remounts
        if (!form.value.dayOfMonth) {
          setValue('dayOfMonth', ''+new Date().getDate())
          setValue('periodMonths', null)
        }
      } else if (form.value.dayOfMonth) {
        type.value = 'monthly'
      } else if (props.addSplit && form.value.periodMonths) {
        type.value = 'split'
      }
    })

    // Watch for changes in dayOfMonth to update the radio button state
    watch(() => form.value.dayOfMonth, (newValue) => {
      if (newValue) {
        type.value = 'monthly'
      } else if (type.value === 'monthly' && !props.onlyMonthly) {
        type.value = 'single'
      }
    })

    function setSingle() {
      type.value = 'single'
      setValue('dayOfMonth', null)
      setValue('periodMonths', null)
    }

    function setMonthly() {
      type.value = 'monthly'
      setValue('dayOfMonth', ''+new Date().getDate())
      setValue('periodMonths', null)
    }

    function setSplit() {
      type.value = 'split'
      setValue('dayOfMonth', null)
      setValue('periodMonths', '2')
    }
    
    return {
      isEs,
      form,
      duration: computed(() => form.value.periodMonths),
      setSplit,
      setSingle,
      setMonthly,
      setValue,
      type,
      splitAmount,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!

        const j = i % 10,
          k = i % 100
        if (j == 1 && k != 11) {
          return i + 'st'
        }
        if (j == 2 && k != 12) {
          return i + 'nd'
        }
        if (j == 3 && k != 13) {
          return i + 'rd'
        }
        return i + 'th'
      }),
    }
  },
})
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;
  select {
    max-width: calc(22% - 10px);
    margin-right: 10px;
    min-width: 120px;
  } 
}

.radio__label{

}
.radio-group{
  display: flex;
  width: 100%;
  margin-bottom: 24px;
}
.radio__part{
  flex: 1;
      input[type='radio'] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label{

    border-radius: 100px 0 0 100px;
border-radius: 0 99px 99px 0;
border-top: 1px solid var(--Grayscale-Ash, #160D10);
border-right: 1px solid var(--Grayscale-Ash, #160D10);
border-bottom: 1px solid var(--Grayscale-Ash, #160D10);
color: var(--Grayscale-Ash, #160D10);
text-align: center;

/* Desktop/Text/Condensed/Action - Regular */
font-family: "Blinker";
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 3px;
text-transform: uppercase;
vertical-align: middle;
cursor: pointer;
display: flex;
min-height: 44px;
padding: 10px 16px;
justify-content: center;
align-items: center;
flex: 1 0 0;
width: 100%;


      @media only screen and (max-width: 720px) {
// font-weight: 500;
// font-size: 14px;
// line-height: 20px;
// width: 100px;
// height: 40px;
      }

      &:hover{
           background: rgba(22, 13, 16, 0.12);
    }
  }
   input[type='radio']:checked + label {
background: var(--Grayscale-Ash, #160D10);
color: var(--White, #FFF);
   }

   &:first-child label {
    border-radius: 100px 0 0 100px;
   }
   &:last-child label {
    border-radius: 0 99px 99px 0; 
   }
}

.paymenttype__svg--mobile{
  display: flex;
        @media only screen and (min-width: 720px) {
     display: none;
    }
}

.paymenttype__svg{
    display: flex;
        @media only screen and (max-width: 720px) {
     display: none;
    }
}
.selectdoantion__label{
    color: var(--Grayscale-Ash, #160D10);
    padding: 0px 0px 8px;
    display: block;
    font-family: "Albert Sans";
    font-size: 14px;
text-align: left;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    text-transform: capitalize;

}
 select{
    padding:9px 12px;
    // height: 40px;
    // background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    margin: 0px 10px;
    align-items: center;
    color: #4a4d50;

    &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
    }
    }
</style>